export const walletRoutePrefixes = [
  "/coins",
  "/b/wallet",
  "/wallet",
  "/tip",
];
